import {html, css, LitElement, nothing} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {localize} from '@/shared/localize/tcg-localize-behavior';
import sharedStyles from '@/shared/styles/tcg-shared-styles.js';
import {styleMap} from 'lit/directives/style-map.js';

/**
 * `tcg-noresults`
 * No results empty state component
 *
 * @customElement
 */
@customElement('tcg-noresults')
class TcgNoresults extends LitElement {
    static styles = [
        sharedStyles,
        css`
            :host {
                display: flex;
                width: 100%;
                justify-content: center;
            }

            .center {
                width: 100%;
                max-width: var(--tcg-content-max-width);
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .imageData {
                width: 400px;
                height: 400px;
            }
        `,
    ];

    @property({type: String})
    accessor title = '';

    @property({type: String, attribute: 'localize-title'})
    accessor localizeTitle = '';

    @property({type: String})
    accessor text = '';

    @property({type: String, attribute: 'localize-text'})
    accessor localizeText = '';

    @property({type: String, attribute: 'image-src'})
    accessor imageSrc = '/images/default-empty-state.svg';

    @property({type: Boolean, attribute: 'visible'})
    accessor visible = true;

    render() {
        if (!this.visible) {
            return nothing;
        }

        const titleText = this.localizeTitle ? localize(this.localizeTitle) : this.title;
        const bodyText = this.localizeText ? localize(this.localizeText) : this.text;
        const imageStyle = styleMap({
            backgroundImage: `url(${this.imageSrc})`,
        });

        return html`
            <div class="center">
                <div class="titleText">${titleText}</div>
                <div class="body1Text">${bodyText}</div>
                <div
                    class="imageData"
                    style=${imageStyle}
                ></div>
            </div>
        `;
    }
}
